import React from 'react';
import { MediaList } from 'components/media-list/MediaList';
import { MediaListItem } from 'components/media-list/MediaListItem';

export const Component = () => {
  const image = { url: 'https://picsum.photos/id/942/480/640', width: 480, height: 640 };

  return (
    <>
      <MediaList title="Logos" archive={{ href: 'https://picsum.photos/id/942/640/560' }} isSlice>
        <MediaListItem title="Dark Grey on White" subline="JPEG" image={image} />
        <MediaListItem title="Yellow on Dark Grey" subline="JPEG" image={image} />
      </MediaList>
      <MediaList
        title="Logos"
        aspect="Portrait"
        archive={{ href: 'https://picsum.photos/id/942/640/560' }}
        isSlice
      >
        <MediaListItem title="Dark Grey on White" subline="JPEG" image={image} />
        <MediaListItem title="Yellow on Dark Grey" subline="JPEG" image={image} />
        <MediaListItem title="Dark Grey on Yellow" subline="JPEG" image={image} />
      </MediaList>
      <MediaList title="Logos" archive={{ href: 'https://picsum.photos/id/942/640/560' }} isSlice>
        <MediaListItem title="Dark Grey on White" subline="JPEG" image={image} />
        <MediaListItem title="Yellow on Dark Grey" subline="JPEG" image={image} />
        <MediaListItem title="Dark Grey on Yellow" subline="JPEG" image={image} />
        <MediaListItem title="Dark Grey on Yellow" subline="JPEG" image={image} />
      </MediaList>
    </>
  );
};
